import dynamic from 'next/dynamic';
const ClientSuccess = dynamic(() => import('./ClientSuccess'));
export default ClientSuccess;
